import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { Container, Box, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Information from '../../PracticesPage/Components/Information';
import capitalize from '../../../Helpers/StringsFormatting/capitalize';
import { culture, options } from '../../../Helpers/dates';
import StatusChip from '../../../Components/Chip/StatusChip';
import { PURCHASE_COLORS, PURCHASE_ICONS } from '../Utils/constants';
import ConfirmPopup from '../../../Components/Popup/ConfirmPopup';

const useStyles = () => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    gap: '2%',
    alignItems: 'center',
    maxHeight: '80px',
    pt: '12px',
    pb: '12px',
  },
});

const PurchaseListItem = function PurchaseListItem({
  data = {},
  onClick,
  onDelete,
  onSendPurchaseRequest,
  onAcceptPurchaseRequest,
  userInfo,
}) {
  const intl = useIntl();
  const classes = useStyles();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmDelete, setIsDelete] = useState(false);
  const [confirmAccept, setConfirmAccept] = useState(false);
  const isAccounting = userInfo.userRoles.some(
    ({ roleId }) => roleId === 'ACCOUNTING'
  );

  const openConfirmDeletion = (event) => {
    event.stopPropagation();
    setIsDelete(event.currentTarget);
  };

  const openEditDialogHandler = () => {
    onClick(data);
  };

  const confirmSendPurchaseRequest = (event) => {
    event.stopPropagation();
    setConfirmOpen(event.currentTarget);
  };

  const confirmAcceptPurchaseRequest = (event) => {
    event.stopPropagation();
    setConfirmAccept(event.currentTarget);
  };

  return (
    <>
      <Container
        id="list-entry"
        sx={classes.root}
        style={{
          maxWidth: 'unset',
          flex: 'auto',
        }}
      >
        <Information
          caption={intl.messages.USER}
          value={capitalize(data.userFullName)}
        />
        <Information
          caption={intl.messages.CREDIT_SMS_QUANTITY}
          value={data.creditsSMSQuantity.toString()}
        />
        <Information
          caption={intl.messages.COST}
          value={data.cost.toString()}
        />
        <Information
          caption={intl.messages.UNIT_PRICE}
          value={data.unitPrice.toString()}
        />
        <Information
          caption={intl.messages.PURCHASE_CONFIRM_DATE}
          value={
            data.purchaseConfirmDate
              ? new Date(data.purchaseConfirmDate).toLocaleDateString(
                  culture,
                  options
                )
              : null
          }
        />
        <Information
          caption={intl.messages.PURCHASE_REQUEST_DATE}
          value={
            data.purchaseRequestDate
              ? new Date(data.purchaseRequestDate).toLocaleDateString(
                  culture,
                  options
                )
              : null
          }
        />
        <Box
          sx={{
            maxWidth: '140px',
            minWidth: '140px',
            display: 'flex',
          }}
        >
          <Tooltip
            title={
              data.purchaseStateID === 1
                ? intl.messages.CLICK_SEND_REQUEST
                : data.purchaseStateID === 2 && isAccounting
                  ? intl.messages.CLICK_CONFIRM_REQUEST
                  : ''
            }
            placement="bottom"
            sx={{ padding: '0px' }}
          >
            <StatusChip
              status={data.state?.toLowerCase()}
              {...(data.purchaseStateID === 2 && isAccounting
                ? { onClick: confirmAcceptPurchaseRequest }
                : {
                    ...(data.purchaseStateID === 1 && !isAccounting
                      ? { onClick: confirmSendPurchaseRequest }
                      : {}),
                  })}
              options={PURCHASE_ICONS}
              colors={PURCHASE_COLORS}
            />
          </Tooltip>
        </Box>
        <Box
          sx={{
            minWidth: '64px',
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
          }}
        >
          {data.purchaseStateID === 1 && (
            <>
              <Tooltip
                title={intl.messages.EDIT_PURCHASE}
                placement="bottom"
                sx={{ padding: '0px' }}
              >
                <IconButton key={data.id} onClick={openEditDialogHandler}>
                  <EditIcon />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={intl.messages.DELETE}
                placement="bottom"
                sx={{ paddingRight: '0px' }}
              >
                <IconButton key={data.id} onClick={openConfirmDeletion}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            </>
          )}
        </Box>
      </Container>
      <ConfirmPopup
        confirmText={intl.messages.CONFIRM_DELETE_PURCHASE}
        open={Boolean(confirmDelete)}
        anchorEl={confirmDelete}
        close={() => setIsDelete(null)}
        handleConfirm={() => onDelete(data.id)}
      />
      <ConfirmPopup
        confirmText={intl.messages.CONFIRM_SEND_PURCHASE}
        open={Boolean(confirmOpen)}
        anchorEl={confirmOpen}
        close={() => setConfirmOpen(null)}
        handleConfirm={() => onSendPurchaseRequest(data.id)}
      />
      <ConfirmPopup
        confirmText={intl.messages.ACCEPT_PURCHASE_REQUEST}
        open={Boolean(confirmAccept)}
        anchorEl={confirmAccept}
        close={() => setConfirmAccept(null)}
        handleConfirm={() => onAcceptPurchaseRequest(data.id)}
      />
    </>
  );
};

export default PurchaseListItem;
